module.exports = __webpack_public_path__ + "static/media/step-indicator-2.9d2a1ff4.svg";